import type { ReactNode } from 'react'
import type { AuthLayoutPanel } from '@/widgets/auth-layout'
import { Footer } from '@/widgets/footer'
import { Header } from '@/widgets/header'
import { designTokens } from '@/shared/lib/design-tokens'
import registrationCharacters from '@/shared/assets/registration/registration-characters.svg'
import type {
  AuthBadgeLayout,
  AuthBadgeSurfaceVariant,
  AuthBadgeTextVariant,
} from './registration-badge'
import { AuthBadge } from './registration-badge'

const registrationTokens = designTokens.components.registration.desktop
const badgeTokens = registrationTokens.badges

const desktopBadges = [
  {
    label: 'маркетологи',
    textVariant: 'desktopSm',
    surfaceVariant: 'desktop',
    layout: badgeTokens.marketersTop,
  },
  {
    label: 'C-level',
    textVariant: 'desktopLg',
    surfaceVariant: 'desktop',
    layout: badgeTokens.cLevel,
  },
  {
    label: 'предприниматели',
    textVariant: 'desktopLg',
    surfaceVariant: 'desktop',
    layout: badgeTokens.entrepreneurs,
  },
  {
    label: 'владельцы бизнеса',
    textVariant: 'desktopSm',
    surfaceVariant: 'desktop',
    layout: badgeTokens.businessOwners,
  },
  {
    label: 'продакты',
    textVariant: 'desktopSm',
    surfaceVariant: 'desktop',
    layout: badgeTokens.products,
  },
  {
    label: 'маркетологи',
    textVariant: 'desktopSm',
    surfaceVariant: 'desktop',
    layout: badgeTokens.marketersBottom,
  },
  {
    label: 'CPO',
    textVariant: 'desktopSm',
    surfaceVariant: 'desktop',
    layout: badgeTokens.cpo,
  },
] satisfies Array<{
  label: string
  textVariant: AuthBadgeTextVariant
  surfaceVariant: AuthBadgeSurfaceVariant
  layout: AuthBadgeLayout
}>

type RegistrationPageDesktopProps = {
  panel: AuthLayoutPanel
  renderAuthLayout: (variant: 'desktop' | 'mobile') => ReactNode
}

export function RegistrationPageDesktop({ panel, renderAuthLayout }: RegistrationPageDesktopProps) {
  const showDecor = panel === 'email'

  return (
    <>
      {showDecor ? (
        <div className="pointer-events-none absolute inset-0 hidden lg:block">
          <div
            className="absolute"
            style={{
              width: registrationTokens.frame.width,
              height: registrationTokens.frame.height,
              left: '50%',
              bottom: 0,
              transform: 'translateX(-50%)',
            }}
          >
            <img
              src={registrationCharacters}
              alt=""
              aria-hidden="true"
              className="absolute"
              style={{
                left: registrationTokens.characters.x,
                top: registrationTokens.characters.y,
                width: registrationTokens.characters.width,
                height: registrationTokens.characters.height,
              }}
            />

            {desktopBadges.map((badge) => (
              <AuthBadge key={`${badge.label}-${badge.layout.x}-${badge.layout.y}`} {...badge} />
            ))}
          </div>
        </div>
      ) : null}

      <div
        className="relative hidden min-h-screen w-full flex-col items-center lg:flex"
        style={{
          maxWidth: registrationTokens.frame.width,
        }}
      >
        <div className="w-full">
          <Header />
        </div>

        <main className="relative flex w-full flex-1 items-start justify-center">
          <div
            className="relative z-10 w-full"
            style={{
              maxWidth: registrationTokens.panel.width,
              marginTop: designTokens.spacing.authPanelDesktopTop,
            }}
          >
            {renderAuthLayout('desktop')}
          </div>
        </main>

        <div
          className="w-full"
          style={{
            maxWidth: registrationTokens.footer.width,
          }}
        >
          <Footer />
        </div>
      </div>
    </>
  )
}
